<template>
  <v-dialog v-model="value" width="700" persistent>
    <v-card>
      <v-card-title primary-title class="px-2 py-1 blue-grey lighten-4">
        <v-btn class="ma-0" icon @click.native="printMethod">
          <v-icon>print</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn class="ma-0" icon @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <div id="section-to-print" ref="print_area">
          <slot name="form"></slot>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { printBill } from "@/mixins";
export default {
  mixins: [printBill],
  props: {
    value: {
      default: false,
    },
  },

  methods: {
    printMethod() {
      this.printBill(this.$slots.form[0].elm, false);
    },
  },
};
</script>

<style >
.bill {
  padding: 15px;
  padding-top: 5px;
  position: relative;
  background-color: white;
  background-size: 100mm auto;
  background-repeat: no-repeat;
  background-position: center center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important;
}
table.greyGridTable {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}

.bill-footer {
  margin-top: 10px;
}

.bill-footer strong {
  font-size: 14px;
  font-weight: 500;
}
table.greyGridTable td,
table.greyGridTable th {
  border: 1px solid #42494f;
  padding: 4px 8px;
}
table.greyGridTable tbody td {
  font-size: 13px;
}

#total {
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
}

@media print {
  .bill {
    box-shadow: none !important;
    border: none !important;
    -webkit-box-shadow: none !important;
  }
}

.bill_label {
  text-align: left !important;
}
.bill_value {
  text-align: left !important;
}
.application--is-rtl .bill_label {
  text-align: right !important;
}
.application--is-rtl .bill_value {
  text-align: left !important;
}

.bill_logo {
  /* width: 1.5cm; */
  /* alokozay */
  width: 2cm; 

  height: auto;
}

</style>